import type { I18nFn } from 'i18n/types/I18nFn';

export enum OrgType {
  NONPROFIT = 'NONPROFIT',
  GOVERNMENT = 'GOVERNMENT',
  CORPORATION = 'CORPORATION',
  CONSULTANT = 'CONSULTANT',
  RECRUITER = 'RECRUITER',
  COMMUNITY = 'COMMUNITY',
}

export const ORG_TYPES = (i18n: I18nFn) =>
  ({
    [OrgType.NONPROFIT]: i18n('Nonprofit'),
    [OrgType.GOVERNMENT]: i18n('Government'),
    [OrgType.CORPORATION]: i18n('Business'),
    [OrgType.CONSULTANT]: i18n('Consultant'),
    [OrgType.RECRUITER]: i18n('Recruiter'),
    [OrgType.COMMUNITY]: i18n('Community Group'),
  }) satisfies Record<OrgType, string>;

export const ORG_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const ORG_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
